/* eslint-disable @typescript-eslint/no-explicit-any */
export default function (router: any) {
  if (localStorage.getItem("access_token")) {
    return router.next({ name: "user-management" });
  }
  return router.next();
}
